import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppGuard } from '../../services/auth.guard';
import { PedidosComponent } from './pedidos/pedidos.component';
import { PedidoMaterialComponent } from './pedido-material/pedido-material.component';
import { FornecedoresComponent } from './fornecedores/fornecedores.component';
import { CadastrarFornecedorComponent } from './cadastrar-fornecedor/cadastrar-fornecedor.component';

const routes: Routes = [
  {
    path: 'suprimentos',
    component: PedidosComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'] },
  },
  {
    path: 'suprimentos/cadastrar-pedido',
    component: PedidoMaterialComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'] },
  },
  {
    path: 'fornecedores/cadastrar-fornecedor',
    component: CadastrarFornecedorComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'] },
  },
  {
    path: 'fornecedores',
    component: FornecedoresComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'] },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class SuprimentosRoutingModule {}
